import { CalendarClock, Zap, PiggyBank, ShieldCheck } from 'lucide-react';
import { Reveal, SectionHeading } from '../components/Reveal';
import { Counter } from '../components/Counter';

const BENEFITS = [
  {
    icon: <CalendarClock className="h-5 w-5" />,
    title: 'Smart Lead Capture',
    tag: '24/7 Availability',
    copy: "Our AI assistant answers calls 24/7, captures leads, and keeps your business running even when you're not available.",
  },
  {
    icon: <Zap className="h-5 w-5" />,
    title: 'Automated Follow-Ups',
    tag: 'Never lose a lead',
    copy: 'Automatically send follow-ups through email, SMS, or calls after every conversation.',
  },
  {
    icon: <PiggyBank className="h-5 w-5" />,
    title: 'Reduce Operational Costs',
    tag: 'Do more with less',
    copy: 'Lower overhead expenses by optimizing resources and streamlining workflows with intelligent AI automation.',
  },
  {
    icon: <ShieldCheck className="h-5 w-5" />,
    title: 'Secure & Reliable',
    tag: 'Enterprise grade',
    copy: 'Advanced security and dedicated infrastructure keep your business conversations protected.',
  },
];

const STATS = [
  { value: 1100, suffix: '+', label: 'Members' },
  { value: 500, suffix: '+', label: 'Users' },
  { value: 5, suffix: '/5', label: 'Average rating' },
  { value: 80, suffix: '%', label: 'Time saved' },
];

export const Benefits = () => (
  <section className="py-20 lg:py-28" id="benefits" data-testid="benefits-section">
    <div className="container-x">
      <SectionHeading
        eyebrow="Why Choose Us"
        title="Empower Your Business"
        sub="Let AI handle conversations while you focus on growing your business."
        center
      />

      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {BENEFITS.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.06} data-testid={`benefit-card-${i}`}>
            <div className="h-full rounded-3xl border border-brand-line bg-white p-7 shadow-card transition-all duration-300 hover:-translate-y-1 hover:shadow-lift">
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-brand-ice text-brand-skyDeep">
                {b.icon}
              </span>
              <p className="mt-5 text-xs font-bold uppercase tracking-[0.18em] text-brand-skyDeep">{b.tag}</p>
              <h3 className="mt-2 text-lg font-bold tracking-tight">{b.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{b.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div
          className="mt-12 grid gap-8 rounded-[2rem] border border-brand-line bg-gradient-to-r from-brand-ice to-brand-iceSoft p-8 shadow-soft sm:grid-cols-2 lg:grid-cols-4 lg:p-10"
          data-testid="stats-band"
        >
          {STATS.map((s) => (
            <div key={s.label} className="text-center">
              <p className="text-3xl font-extrabold tracking-tight text-brand-navy lg:text-4xl">
                <Counter to={s.value} suffix={s.suffix} />
              </p>
              <p className="mt-1 text-sm font-semibold text-brand-body/70">{s.label}</p>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
